export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'divider',
		label: 'Divider',
		selector: '& .divider'
  },
  {
		name: 'text',
		label: 'Text',
		selector: '& .text'
	}
]
